import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full height of the viewport */
  background-color: #f0f4f8; /* Light background color */
`;

const TermsBox = styled.div`
  width: 90%; /* Width of the box */
  max-width: 800px; /* Maximum width */
  background-color: white; /* White background for the box */
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Shadow for depth */
  padding: 20px; /* Padding inside the box */
  overflow-y: auto; /* Enable vertical scrolling */
  max-height: 80vh; /* Maximum height of the box */
`;

const Title = styled.h1`
  margin: 0 0 20px; /* Margin below the title */
`;

const Subtitle = styled.h2`
  margin-top: 20px; /* Margin above each subtitle */
`;

const TermsPage = () => (
  <Container>
    <TermsBox>
      <Title>Terms and Conditions</Title>
      <p><strong>Last Updated: [November 2nd 2024]</strong></p>

      <Subtitle>1. Acceptance of Terms</Subtitle>
      <p>By using NotesFromBeyond.com (the “Service”), you agree to these Terms and Conditions. If you do not agree, please do not use the Service. This document outlines the terms and conditions for creating and scheduling posthumous emails.</p>

      <Subtitle>2. Description of Service</Subtitle>
      <p>The Service allows users to create and schedule emails to be sent at a specified time, including after payment cessation or the user’s passing. NotesFromBeyond.com does not assume responsibility for the accuracy or delivery of these messages and provides no guarantees on specific outcomes.</p>

      <Subtitle>3. User Responsibilities</Subtitle>
      <p>You are solely responsible for the content of the emails you create and any consequences arising from their delivery. By using this Service, you agree not to submit any content that is defamatory, illegal, or violates any third-party rights. You affirm that you have the right to make arrangements for emails to be sent on your behalf after your passing.</p>

      <Subtitle>4. Subscription and Payment Terms</Subtitle>
      <p>Our Service is subscription-based. Scheduled emails are sent only if your payments are current. Non-payment, payment cessation, or cancellation of your subscription will halt future email deliveries. NotesFromBeyond.com reserves the right to cancel or suspend subscriptions at our discretion.</p>

      <Subtitle>5. Limitation of Liability</Subtitle>
      <p>To the maximum extent permitted by law, NotesFromBeyond.com and its affiliates are not liable for any damages resulting from delayed, unsent, misdelivered, or non-received emails, or for any claims arising from the content of these emails. You agree to hold NotesFromBeyond.com harmless for any harm or loss resulting from your use of the Service.</p>

      <Subtitle>6. Termination of Service</Subtitle>
      <p>We reserve the right to terminate or suspend your access to the Service for any reason, including breach of these Terms. Upon termination, we are not responsible for delivering scheduled emails.</p>

      <Subtitle>7. Posthumous Instructions and Consent</Subtitle>
      <p>By using the Service, you consent to posthumous email sending based on your instructions. You affirm that this Service does not replace any legal or personal representative arrangements.</p>

      <Subtitle>8. Disclaimer of Legal Validity</Subtitle>
      <p>This Service does not replace legal documents or official directives. You understand and agree that this Service is not intended for sensitive or legally binding communications, such as wills, financial instructions, or legal notices.</p>

      <Subtitle>9. Indemnification</Subtitle>
      <p>You agree to indemnify and hold harmless NotesFromBeyond.com, its affiliates, and agents from any claims, damages, or costs, including legal fees, arising from (i) your use of the Service, (ii) the content you create, or (iii) delivery of emails as scheduled.</p>

      <Subtitle>10. Jurisdiction and Governing Law</Subtitle>
      <p>These Terms are governed by the laws of the Commonwealth of Massachusetts, USA. Any disputes arising from these Terms will be subject to the exclusive jurisdiction of the courts in Massachusetts.</p>

      <Subtitle>11. Changes to Terms</Subtitle>
      <p>We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the new terms.</p>
    </TermsBox>
  </Container>
);

export default TermsPage;
